import React, { FunctionComponent } from 'react';
import Media from 'react-media';
import { Container, Column, Row } from '@iag-packages/chroma-react/lib/layouts';

import { Accordion, AccordionItem } from 'components/chroma';
import FlybuysInfoSection from 'scenes/common/components/FlybuysInfo/FlybuysInfoSection';
import { SCREEN } from 'scenes/common/types/screen';
import QuoteNumberCard from 'scenes/common/components/QuoteInformation/QuoteNumberCards/QuoteNumberCard';
import MarketingCampaign from 'scenes/common/components/MarketingCampaign/MarketingCampaign';

import { FooterTopProps } from './types';
import { FooterLinks } from './FooterLinks';

const FooterTopDesktop: FunctionComponent<FooterTopProps> = ({
  quoteNumber,
  campaign,
  showQuoteInformation,
  pageNotLoadingOrError,
  showFooterQuoteInformation,
  showFlybuys,
  showMarketingCampaign,
  additionalComponents,
  informationLinks,
  insuranceName,
  saveOnlineInformation,
  awardsToDisplay,
  initialAccordionActiveItems,
  isBeforeEffectiveEndDate,
}) => (
  <>
    {showFooterQuoteInformation && showQuoteInformation && (
      <Media
        query={{ maxWidth: SCREEN.LARGE - 1, minWidth: SCREEN.MEDIUM + 1 }}
      >
        {(matches) =>
          matches ? (
            <Container>
              <Row>
                <Column xs={12} md={6} mdOffset={3}>
                  <QuoteNumberCard
                    quoteNumber={quoteNumber}
                    isBeforeEffectiveEndDate={isBeforeEffectiveEndDate}
                  />
                </Column>
              </Row>
            </Container>
          ) : (
            <></>
          )
        }
      </Media>
    )}

    {showFlybuys && pageNotLoadingOrError && (
      <Media
        query={{ maxWidth: SCREEN.LARGE - 1, minWidth: SCREEN.MEDIUM + 1 }}
      >
        {(matches) =>
          matches ? (
            <Container>
              <Row justifyContent="center">
                <Column xs={12} md={6}>
                  <FlybuysInfoSection insuranceName={insuranceName} />
                </Column>
              </Row>
            </Container>
          ) : (
            <></>
          )
        }
      </Media>
    )}
    {showMarketingCampaign && showQuoteInformation && (
      <Media
        query={{ maxWidth: SCREEN.LARGE - 1, minWidth: SCREEN.MEDIUM + 1 }}
      >
        {(matches) =>
          matches ? (
            <Container>
              <Row>
                <Column xs={12} md={6} mdOffset={3}>
                  <MarketingCampaign
                    quoteNumber={quoteNumber}
                    campaign={campaign}
                  />
                </Column>
              </Row>
            </Container>
          ) : (
            <></>
          )
        }
      </Media>
    )}
    {/** Not a great pattern, but following what's here... */}
    <Media query={{ maxWidth: SCREEN.LARGE - 1, minWidth: SCREEN.MEDIUM + 1 }}>
      {(matches) =>
        matches ? (
          <>
            {awardsToDisplay && (
              <Container>
                <Row margin={{ bottom: 5 }}>
                  <Column xs={12} md={6} mdOffset={3}>
                    {awardsToDisplay.map((Award) => (
                      <Award />
                    ))}
                  </Column>
                </Row>
              </Container>
            )}
          </>
        ) : (
          <></>
        )
      }
    </Media>
    {additionalComponents &&
      additionalComponents.length > 0 &&
      showQuoteInformation && (
        <Container>
          <Row>
            <Column xs={12} md={6} mdOffset={3} margin={{ bottom: 5 }}>
              <Accordion>
                {additionalComponents.map(({ text, component }) => (
                  <AccordionItem
                    activeItems={
                      initialAccordionActiveItems !== undefined
                        ? initialAccordionActiveItems
                        : [0]
                    }
                    key={text}
                    label={{ text }}
                    content={{ component }}
                  />
                ))}
              </Accordion>
            </Column>
          </Row>
        </Container>
      )}
    <Container>
      <Row>
        <Column xs={12} md={10} mdOffset={1}>
          <FooterLinks informationLinks={informationLinks} />
        </Column>
      </Row>
    </Container>
    {saveOnlineInformation && (
      <Container>
        <Row>
          <Column xs={12} md={10} mdOffset={1}>
            {saveOnlineInformation}
          </Column>
        </Row>
      </Container>
    )}
  </>
);

export default FooterTopDesktop;
